/* eslint-disable import/no-cycle */
import axios from "axios";
import { GET_COLORS } from "lib/constants";
import { getAPICall } from "../lib/callApi";

// axios.defaults.baseURL = 'http://localhost:8000'

// eslint-disable-next-line import/prefer-default-export
export const getUsersAPI = async (payload) =>
  axios.post(`${process.env.REACT_APP_API_URL}/user/userLogin`, payload);

export const fetchColors = async () => {
  const data = await getAPICall(GET_COLORS, true);
  return data;
};
